import ExtendedLandlordInformation from './ExtendedLandlordInformation';

export default ExtendedLandlordInformation;
